import Login from '@/components/login/Login';
import Content from '@/components/content/Index';
import ContentBox from '@/components/content/box/Content.vue';
// users module route file
import UsersList from '@/components/content/users/List.vue';
import UsersAdd from '@/components/content/users/Add.vue';
// -------end-------
// permissions module route file
import PermissionsList from '@/components/content/permissions/List.vue';
import PermissionsAdd from '@/components/content/permissions/Add.vue';
// -------end-------
// h5 module route file
import H5List from '@/components/content/h5/List.vue';
import H5Add from '@/components/content/h5/Add.vue';
import H5Data from '@/components/content/h5/Data.vue';
// -------end-------
// business module route file
import BusinessList from '@/components/content/business/List.vue';
import BusinessAdd from '@/components/content/business/Add.vue';
import BusinessEdit from '@/components/content/business/Edit.vue';
import BusinessAd from '@/components/content/business/Ad.vue';
import BusinessNews from '@/components/content/business/News.vue';
import BusinessTemplate from '@/components/content/business/Template.vue';
// -------end-------
// market module route file
import MarketList from '@/components/content/market/List.vue';
import MarketAdd from '@/components/content/market/Add.vue';
import MarketEdit from '@/components/content/market/Edit.vue';
import MarketModule from '@/components/content/market/Module.vue';
import MarketNews from '@/components/content/market/News.vue';
import MarketTemplate from '@/components/content/market/Template.vue';
// -------end-------
// kvlive module route file
import KVliveList from '@/components/content/kvlive/List.vue';
import KVliveAdd from '@/components/content/kvlive/Add.vue';
import KVliveComment from '@/components/content/kvlive/Comment.vue';
// -------end-------
// ugclive module route file
import UGCliveList from '@/components/content/ugclive/List.vue';
import UGCliveAdd from '@/components/content/ugclive/Add.vue';
import UGCliveComment from '@/components/content/ugclive/Comment.vue';
import UGClivePush from '@/components/content/ugclive/Push.vue';
// -------end-------
// crawler module route file
import CrawlerBusiness from '@/components/content/crawler/Business.vue';
import CrawlerMarket from '@/components/content/crawler/Market.vue';
// -------end-------
// topic module route file
import TopicList from '@/components/content/topic/List.vue';
import TopicAdd from '@/components/content/topic/Add.vue';
import TopicComment from '@/components/content/topic/Comment.vue';
import TopicBusiness from '@/components/content/topic/Business.vue';
// vote module route file
import VoteList from '@/components/content/vote/List.vue';
import VoteAdd from '@/components/content/vote/Add.vue';
import VoteEdit from '@/components/content/vote/Edit.vue';
// -------end-------
// lottery module route file
import DealData from '@/components/content/lottery/DealData.vue';
import LinkGenerate from '@/components/content/lottery/LinkGenerate.vue';
// -------end-------
// ttyq module route file
import TTYQLinkGenerate from '@/components/content/ttyq/LinkGenerate.vue';
// -------end-------
// tool module route file
import Tool from '@/components/tools/Index.vue';
// -------end-------
// sell module route file
import ZhikeSeller from '@/components/content/sell/ZhikeSeller.vue';
import QudaoYesterdayList from '@/components/content/sell/QudaoYesterdayList.vue';
import ZhikeYesterdayList from '@/components/content/sell/ZhikeYesterdayList.vue';
import QudaoSeller from '@/components/content/sell/QudaoSeller.vue';
import SellDataTime from '@/components/content/sell/DataTime.vue';
// -------end-------

const ROUTE_DATA = [{
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/',
        redirect: {
            name: 'Login'
        }
    },
    {
        path: '/content/:userId/:accountEmail/:version',
        name: 'Content',
        component: Content,
        children: [{
                path: 'users',
                name: 'users',
                component: ContentBox,
                children: [{
                        path: 'list',
                        name: 'usersList',
                        component: UsersList
                    },
                    {
                        path: 'add',
                        name: 'usersAdd',
                        component: UsersAdd
                    }
                ]
            },
            {
                path: 'permissions',
                name: 'permissions',
                component: ContentBox,
                children: [{
                        path: 'list',
                        name: 'permissionsList',
                        component: PermissionsList
                    },
                    {
                        path: 'add',
                        name: 'permissionsAdd',
                        component: PermissionsAdd
                    }
                ]
            },
            {
                path: 'h5',
                name: 'h5',
                component: ContentBox,
                children: [{
                        path: 'list',
                        name: 'h5List',
                        component: H5List
                    },
                    {
                        path: 'add',
                        name: 'h5Add',
                        component: H5Add
                    },
                    {
                        path: 'data',
                        name: 'h5Data',
                        component: H5Data
                    }
                ]
            },
            {
                path: 'business',
                name: 'business',
                component: ContentBox,
                children: [{
                        path: 'list',
                        name: 'businessList',
                        component: BusinessList
                    },
                    {
                        path: 'add',
                        name: 'businessAdd',
                        component: BusinessAdd
                    },
                    {
                        path: 'edit',
                        name: 'businessEdit',
                        component: BusinessEdit
                    },
                    {
                        path: 'news',
                        name: 'businessNews',
                        component: BusinessNews
                    },
                    {
                        path: 'ad',
                        name: 'businessAd',
                        component: BusinessAd
                    },
                    {
                        path: 'template',
                        name: 'businessTemplate',
                        component: BusinessTemplate
                    }
                ]
            },
            {
                path: 'market',
                name: 'market',
                component: ContentBox,
                children: [{
                        path: 'list',
                        name: 'marketList',
                        component: MarketList
                    },
                    {
                        path: 'add',
                        name: 'marketAdd',
                        component: MarketAdd
                    },
                    {
                        path: 'edit',
                        name: 'marketEdit',
                        component: MarketEdit
                    },
                    {
                        path: 'news',
                        name: 'marketNews',
                        component: MarketNews
                    },
                    {
                        path: 'module',
                        name: 'marketModule',
                        component: MarketModule
                    },
                    {
                        path: 'template',
                        name: 'marketTemplate',
                        component: MarketTemplate
                    }
                ]
            },
            {
                path: 'kvlive',
                name: 'kvlive',
                component: ContentBox,
                children: [{
                        path: 'list',
                        name: 'kvliveList',
                        component: KVliveList
                    },
                    {
                        path: 'add',
                        name: 'kvliveAdd',
                        component: KVliveAdd
                    },
                    {
                        path: 'comment',
                        name: 'kvliveComment',
                        component: KVliveComment
                    }
                ]
            },
            {
                path: 'ugclive',
                name: 'ugclive',
                component: ContentBox,
                children: [{
                        path: 'list',
                        name: 'ugcliveList',
                        component: UGCliveList
                    },
                    {
                        path: 'add',
                        name: 'ugcliveAdd',
                        component: UGCliveAdd
                    },
                    {
                        path: 'comment',
                        name: 'ugcliveComment',
                        component: UGCliveComment
                    },
                    {
                        path: 'push',
                        name: 'ugclivePush',
                        component: UGClivePush
                    }
                ]
            },
            {
                path: 'crawler',
                name: 'crawler',
                component: ContentBox,
                children: [{
                        path: 'business',
                        name: 'crawlerBusiness',
                        component: CrawlerBusiness
                    },
                    {
                        path: 'market',
                        name: 'crawlerMarket',
                        component: CrawlerMarket
                    }
                ]
            },
            {
                path: 'topic',
                name: 'topic',
                component: ContentBox,
                children: [{
                        path: 'list',
                        name: 'topicList',
                        component: TopicList
                    },
                    {
                        path: 'add',
                        name: 'topicAdd',
                        component: TopicAdd
                    },
                    {
                        path: 'comment',
                        name: 'topicCommit',
                        component: TopicComment
                    },
                    {
                        path: 'business',
                        name: 'topicBusiness',
                        component: TopicBusiness
                    }
                ]
            }, {
                path: 'vote',
                name: 'vote',
                component: ContentBox,
                children: [{
                        path: 'list',
                        name: 'voteList',
                        component: VoteList
                    },
                    {
                        path: 'add',
                        name: 'voteAdd',
                        component: VoteAdd
                    },
                    {
                        path: 'edit',
                        name: 'voteEdit',
                        component: VoteEdit
                    }
                ]
            }, {
                path: 'lottery',
                name: 'lottery',
                component: ContentBox,
                children: [{
                    path: 'deal',
                    name: 'dealData',
                    component: DealData
                }, {
                    path: 'link',
                    name: 'linkGenerate',
                    component: LinkGenerate
                }]
            }, {
                path: 'ttyq',
                name: 'ttyq',
                component: ContentBox,
                children: [{
                    path: 'link',
                    name: 'ttyqLinkGenerate',
                    component: TTYQLinkGenerate
                }]
            }, {
                path: 'sell',
                name: 'sell',
                component: ContentBox,
                children: [{
                        path: 'zhikeSeller',
                        name: 'zhikeSeller',
                        component: ZhikeSeller
                    }, {
                        path: 'qudaoSeller',
                        name: 'qudaoSeller',
                        component: QudaoSeller
                    },
                    {
                        path: 'zhikeYesterdayList',
                        name: 'zhikeYesterdayList',
                        component: ZhikeYesterdayList
                    }, {
                        path: 'qudaoYesterdayList',
                        name: 'qudaoYesterdayList',
                        component: QudaoYesterdayList
                    }, {
                        path: 'SellDataTime',
                        name: 'SellDataTime',
                        component: SellDataTime
                    }
                ]
            }, {
                path: 'tool',
                name: 'tool',
                component: Tool
            }
        ]
    }
];
export default ROUTE_DATA;


// WEBPACK FOOTER //
// ./src/router/data/router_data.js